export const FORM_NAME = 'CLINICAL_ITEM_PROTOCOL_FORM';
export const QA_ID = 'clinical-item-protocol-main-form-modal';
export const ADVANCED_SEARCH_FORM = 'CLINICAL_ITEM_PROTOCOL_ADVANCED_SEARCH_FORM';
export enum ProtocolTypeList {
  Efficacy = 'efficacy',
  Safety = 'safety',
}
